import { DesignerElement, DesignerImage, DesignerText} from "./DesignerElements";
import {DesignerController} from './DesignerController';
import {Debug} from './Debug'

//initiate designer
var designer: DesignerController;

function loadConfig(){
    Debug.DIVSelectMenu();
    let designerDIV = document.getElementById("designer");
    if(designerDIV){
        //use URL on DIV if available
        let configURL = designerDIV.dataset.config_url;
        if(!configURL){
            //Error, no config URL found, abort loading designer
            console.error("ERROR: Keine Config URL gefunden (data-config-url). Designer kann nicht geladen werden.");
            return;
        }
        //Overwrite config file
        let configOverwriteURL = designerDIV.dataset.config_overwrite_url;
        fetch(configURL)
        .then(response => response.json())
        .then( (data) => {
            designer = new DesignerController(data);
            //Overwrite config if available
            if(configOverwriteURL){
                fetch(configOverwriteURL)
                .then(response => response.json())
                .then( (overwriteData) => {
                    designer.overwriteConfig(overwriteData);
                });
            }
            designer.init();
        });
    }else{
        console.warn("No Desinger DIV element found.")
    }
}

//Document already done loading, start loading designer
if (document.readyState !== 'loading') {
    loadConfig();
}else{
    window.addEventListener('DOMContentLoaded', () => {
        loadConfig();
    });
}

